import { IMatch } from '../pages/tourDetails/TournamentPlay/components/PlayTag/PlayTag';

const PREFIX = 'creativeDetail-';

export function getTiebreakerMatchTitle(t: (key: string) => string): string {
  return t(PREFIX + 'bracketCellAddDeciderMatch');
}

export function getTiebreakerMatchName(
  t: (key: string) => string,
  match: Pick<IMatch, 'isTiebreaker'>,
): string | null {
  if (!match.isTiebreaker) {
    return null;
  }
  return getTiebreakerMatchTitle(t);
}
